import type { ComponentProps } from "react";
import { Link as RouterLink } from "react-router-dom";
import { cn } from "../../../utils";

type Props = ComponentProps<typeof RouterLink>;

const DEFAULT_CLASSES =
  "text-primary-500 no-underline hover:underline active:text-primary-600 visited:text-primary-500";

export const Link = ({ children, ...props }: Props) => {
  return (
    <RouterLink {...props} className={cn(DEFAULT_CLASSES, props.className)}>
      {children}
    </RouterLink>
  );
};
